module.exports = __webpack_public_path__ + "static/media/water_500_detail_04.0a33808f.jpg";